/**
 * 应用根组件：组装全局 Providers 和路由配置。
 */

import type { ReactElement } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { AuthProvider, QueryProvider } from '@/providers'
import { router } from '@/router'

/**
 * App 根组件，包裹 QueryProvider、AuthProvider 和 RouterProvider
 * @returns 应用根节点
 */
function App(): ReactElement {
  return (
    <QueryProvider>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </QueryProvider>
  )
}

export default App
